import React from 'react';
import { OuterWrapper, PageContentWrapper, SiteContentWrapper, Container, Row, MainWrapper } from '~layout';

var DefaultTemplate = function DefaultTemplate(_ref) {
  var main = _ref.main,
      bgStart = _ref.bgStart,
      bgEnd = _ref.bgEnd,
      customBg = _ref.customBg,
      content = _ref.content,
      footer = _ref.footer,
      isFullWidth = _ref.isFullWidth;
  return /*#__PURE__*/React.createElement(OuterWrapper, null, main && /*#__PURE__*/React.createElement(PageContentWrapper, {
    bgStart: bgStart,
    bgEnd: bgEnd,
    customBg: customBg
  }, customBg, /*#__PURE__*/React.createElement(SiteContentWrapper, {
    isFullWidth: isFullWidth
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(MainWrapper, null, main))))), /*#__PURE__*/React.createElement(PageContentWrapper, {
    bgStart: bgStart,
    bgEnd: bgEnd,
    customBg: customBg
  }, content), footer);
};

DefaultTemplate.defaultProps = {
  bgStart: null,
  bgEnd: null,
  main: null,
  content: null,
  customBg: null,
  footer: null,
  isFullWidth: false
};
export default DefaultTemplate;